import { render, staticRenderFns } from "./RemarkUpdateWindow.vue?vue&type=template&id=4b7ef7e8&scoped=true"
import script from "./RemarkUpdateWindow.vue?vue&type=script&lang=js"
export * from "./RemarkUpdateWindow.vue?vue&type=script&lang=js"
import style0 from "./RemarkUpdateWindow.vue?vue&type=style&index=0&id=4b7ef7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ef7e8",
  null
  
)

export default component.exports